import { render, staticRenderFns } from "./EditUserDialog.vue?vue&type=template&id=54feb10f&"
import script from "./EditUserDialog.vue?vue&type=script&lang=js&"
export * from "./EditUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports